<template>
    <div>
        <h3>背景を設定する</h3>
        <p>
            貸し本棚は外部に設置した画像URLを指定するか、あるいはお持ちの画像をアップロードすることで背景画像として設定することができます。
        </p>
        <h4>ポータルの背景</h4>
        <p>
            ポータルの背景を設定すると、ユーザー専用の背景がポータル側に設定されます。
            この画像は使用者以外、誰にも見えません。
            ご自身が執筆に没頭できるような画像を設定すると良いでしょう。
        </p>
        <img src="/img/help/other/10.jpg" alt="ポータル背景設定" class="img-thumbnail mb-3">
        <h5>画像URLの設定</h5>
        <p>
            「ポータル背景画像追加」から背景追加モーダルを表示し、背景に設定したい画像のURLを貼り付けます。
            このとき、必ずhttpsで始まるURLを指定してください。
            モーダル画面の下部に確認のために指定URLの画像を表示します。
            この時点で画像が表示されない場合、それは有効なURLではありません。
        </p>
        <p>
            「ポータル背景追加」ボタンで背景URLを追加します。
        </p>
        <p>
            外部URLの画像を設定する場合は、その画像ファイルの所有者であるか、
            直接リンクすることが許可されているサービスの画像を指定してください。
        </p>
        <img src="/img/help/other/14.jpg" alt="ポータル背景アップロード" class="img-thumbnail mb-3">
        <h5>画像のアップロード</h5>
        <p>
            お持ちの画像を貸し本棚にアップロードすることもできます。
        </p>
        <p>
            画像アップロードタブから背景画像を選択してください。
            アップロードできる画像はjpgかpngで、5MB以内の画像ファイルを選択してください。
            アップロードされた画像は必要に応じて適切なサイズに縮小され、最適化されるため、アップロード時よりも小さいファイルサイズの画像に変換されます。
        </p>
        <p>
            アップロードできる画像の合計サイズは制限されています。
            この制限値はアカウント年齢やその他の利用条項に応じて拡張されることがあります。
        </p>
        <p>
            ポータルの背景画像は最大で {{$store.state.max_background}} 枚まで追加することができます。
            複数枚追加した場合は、追加した順番に一定時間で背景が切り替わります。
        </p>
        <h4>本棚の背景</h4>
        <p>
            本棚の背景を設定すると、本棚専用の背景が設定されます。
            <span class="text-danger">この本棚の背景は、本棚を訪れる人すべてに表示されます。</span>
            利用規約に即した画像を使用してください。
        </p>
        <img src="/img/help/other/11.jpg" alt="本棚背景" class="img-thumbnail mb-3">
        <p>
            本棚の背景もポータル同様、外部URLを指定するか、お持ちの画像をアップロードしてください。
        </p>
        <p>
            本棚の背景画像は最大で {{$store.state.max_background}} 枚まで追加することができます。
            本棚に設定された背景は、本棚のすべてのページに表示されます。
            小説、エピソード、記事、シリーズページにも表示されます。
        </p>
        <p>
            小説、あるいはエピソードに背景を設定している場合、そちらの設定が優先されます。
        </p>
        <h4>小説の背景</h4>
        <p>
            小説の背景画像は、１作品に {{$store.state.max_background}} 枚まで追加することができます。
            小説に背景を設定すると、小説の目次ページ（長編のみ）、エピソードページに背景が表示されます。
            本棚に背景を設定していても、小説の背景が優先的に表示されます。
        </p>
        <img src="/img/help/other/12.jpg" alt="小説背景" class="img-thumbnail mb-3">
        <p>
            小説の背景は、小説の本文一覧画面から設定画面を開くことができます。
            こちらも外部URLを指定するか、画像をアップロードすることができます。
        </p>
        <p>
            短編作品にも背景を設定することができます。
            短編作品は目次ページが無いので、本文ページに背景が表示されます。
        </p>
        <p>
            小説を削除すると、アップロードした背景画像も併せて削除されます。
        </p>
        <h4>エピソードの背景</h4>
        <p>
            エピソードの背景画像は、１エピソードに {{$store.state.max_background_episode}} 枚まで追加することができます。
            エピソードに背景を設定すると、そのエピソードページでは本棚や小説に設定されている背景画像よりも優先的に表示されます。
        </p>
        <img src="/img/help/other/13.jpg" alt="エピソード背景設定" class="img-thumbnail mb-3">
        <p>
            エピソードの背景は、本文編集画面のサイドパネルから追加できます。
            こちらも外部URLを指定するか、画像をアップロードすることができます。
        </p>
        <p>
            エピソードの背景は長編小説のみ設定できます。
            短編小説はエピソードの背景を設定することができません。
        </p>
        <p>
            背景画像をアップロードしているエピソードを削除するか、別のエピソードに糾合すると、
            画像ファイルも併せて削除されます。
        </p>
    </div>
</template>


<style src="../help.scss" scoped lang="scss"></style>


<script>
export default {
    created() {
        this.useHead({
            title: "背景を設定する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>